// Карточка блока (radius 16, surface) с заголовком и необязательной кнопкой «Все» (компонент Title в Figma).
import type { ReactNode } from 'react';
import { t } from '../i18n/i18n';
import styles from './Card.module.css';

export function Card({ title, subtitle, onOpen, children, flush, id }: {
  title?: string; subtitle?: string; onOpen?: () => void; children: ReactNode; flush?: boolean; id?: string;
}) {
  return (
    <section className={styles.card} id={id}>
      {title && (
        <header className={styles.header}>
          <div className={styles.titles}>
            <h3 className={styles.title}>{title}</h3>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          </div>
          {onOpen && <button className={styles.all} onClick={onOpen}>{t('mc_all')}</button>}
        </header>
      )}
      <div className={flush ? undefined : styles.body}>{children}</div>
    </section>
  );
}

/** Обязательная подпись рядом с числами (disclaimer, career_scope, qualification…). */
export function Disclaimer({ children }: { children: ReactNode }) {
  return <p className={styles.disclaimer}>{children}</p>;
}

export function Tiles({ items }: { items: Array<{ label: string; value: ReactNode; tone?: 'live' | 'warning' }> }) {
  return (
    <div className={styles.tiles}>
      {items.map((item, i) => (
        <div key={i} className={styles.tile}>
          <div className={`score ${styles.tileValue} ${item.tone ? styles[item.tone] : ''}`}>{item.value}</div>
          {/* дефис внутри слова — неразрывный: «1st-innings» не рвём на «1st-» / «innings» в узкой плитке */}
          <div className={styles.tileLabel}>{item.label.replace(/(\w)-(\w)/g, '$1\u2011$2')}</div>
        </div>
      ))}
    </div>
  );
}

/** Строка «подпись … значение». С onClick — настоящая кнопка (клавиатура, роль и имя «подпись значение» для диктора);
 *  вид тот же. Не класть кликабельную строку внутрь другой кнопки/ссылки — вложенные интерактивные элементы недопустимы. */
export function KeyValue({ label, value, onClick }: { label: ReactNode; value: ReactNode; onClick?: () => void }) {
  if (onClick) {
    return (
      <button type="button" className={`${styles.kv} ${styles.clickable}`} onClick={onClick}>
        <span className={styles.kvLabel}>{label}</span>
        {/* пробел между ячейками: во флексе не рисуется, а имя доступности — «подпись значение», не слитно */}
        {' '}
        <span className={styles.kvValue}>{value}</span>
      </button>
    );
  }
  return (
    <div className={styles.kv}>
      <span className={styles.kvLabel}>{label}</span>
      <span className={styles.kvValue}>{value}</span>
    </div>
  );
}
